import { render } from "./OffersShop.vue?vue&type=template&id=d7a8c250&scoped=true"
import script from "./OffersShop.vue?vue&type=script&lang=js"
export * from "./OffersShop.vue?vue&type=script&lang=js"

import "./OffersShop.vue?vue&type=style&index=0&id=d7a8c250&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7a8c250"]])

export default __exports__